import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { UserAccountService } from '../_services/user-account.service';
import { SafeUser } from '../_models/safe-user';
import { UsersFilterModel } from '../_models/users-filter-model';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatTableFilter } from 'mat-table-filter';

import { MassEmailService } from '../_services/mass-email.service';
import { MassEmailArgs } from '../_models/mass-email-args';

import { NewUserRequestModel } from '../_models/new-user-request-model';
import { APIOperationResult } from '../_models/apioperation-result';

@Component({
  selector: 'app-admin-cp',
  templateUrl: './admin-cp.component.html',
  styleUrls: ['./admin-cp.component.css']
})
export class AdminCpComponent implements OnInit {

  public displayedColumns: string[] = ["UserId", "FirstName", "LastName", "Email", "IsApproved", "IsDenied", "Role", "OperationButtons"];

  public userDataSource: MatTableDataSource<SafeUser>;

  filterEntity: UsersFilterModel;

  @ViewChild(MatSort) sort: MatSort;

  public massEmailFormModel: any = {
    Subject: "",
    Body: ""
  };

  public massEmailFormGroup: FormGroup;

  constructor(
    public userAccountService: UserAccountService,
    protected dialog: MatDialog,
    public massEmailService: MassEmailService,
    private formBuilder: FormBuilder
  ) {

    var initData = new Array<SafeUser>();

    this.userDataSource = new MatTableDataSource<SafeUser>(initData);

    this.userDataSource.filterPredicate = (data: SafeUser, filter: string) => {
      var ret: boolean = true;

      var filterObj: UsersFilterModel = <UsersFilterModel>JSON.parse(filter);

      function stringFilter(keyName) {
        try {
          var needle = filterObj[keyName];

          if (needle != undefined && needle != null && needle != "") {
            var haystack = data[keyName];
            var ind = haystack.indexOf(needle);

            if (ind == -1) {
              ret = false;
            }
          }
        }
        catch (ex) {

        }
      }
      stringFilter("FirstName");
      stringFilter("LastName");
      stringFilter("Email");
      //stringFilter("Uicnumber");
      //stringFilter("LeaseName");
      //stringFilter("WellNumber");
      //stringFilter("OperatorOperatorName");

      //Filter on the exclude zero injections field.
      /*if (filterObj.ExcludeZeroInjections) {
        if (data.InjectionsCount == 0) {
          ret = false;
        }
      }*/

      return ret;
    };

    this.massEmailFormGroup = this.formBuilder.group(
      {
        'ReturnAddress': [this.massEmailFormModel.ReturnAddress, [Validators.required]],
        'Subject': [this.massEmailFormModel.Subject, [Validators.required]],
        'Body': [this.massEmailFormModel.Body, [Validators.required]]
      });
  }

  ngOnInit(): void {
    this.filterEntity = new UsersFilterModel();
  }

  ngAfterViewInit(): void {
    this.userAccountService.fetchAllUsers().then((result) => {
      this.userDataSource.data = result;
      this.userDataSource.sort = this.sort;
      this.userDataSource.filter = "";
    },
      (err) => {

      });
  }



  applyUserListFilter(event, fieldName: string) {
    this.userDataSource.filter = JSON.stringify(this.filterEntity);

    //Save the state of the filter form
    //this.saveFilterFormState();
  }

  filterFieldHandleClick(event: Event) {
    event.stopPropagation();
  }

  sendMassEmail() {
    let args = new MassEmailArgs();

    let value = this.massEmailFormGroup.value;

    args.ReturnAddress = value.ReturnAddress;
    args.Subject = value.Subject;
    args.Body = value.Body;

    this.massEmailService.sendEmail(args).then(() => {
      alert("Success!");
    },
    (err) => {
      alert("Error occurred.  Message may not have been sent.")
    });


  }
}
